// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__YI2No","footer":"NavbarSimple_footer__i0MFw","link":"NavbarSimple_link__FpyrA","linkIcon":"NavbarSimple_linkIcon__kM-HO"};